'use client'

// libraries
import { useEffect } from 'react'

export default function useTableWrapper() {
    useEffect(() => {
        const handleDomReady = () => {
            const richTextElements = document.querySelectorAll('.rich-text-article')
    
            richTextElements.forEach((richTextElement) => {
                const tables = richTextElement.querySelectorAll('table')
    
                tables.forEach((table) => {
                    if (!table.parentElement?.classList.contains('table-rich-text')) {
                        const wrapper = document.createElement('div')
                        wrapper.classList.add('table-rich-text')
                        
                        table.parentNode?.insertBefore(wrapper, table)
                        wrapper.appendChild(table)
                    }
                })
            })
        }
    
        // wait for the dom to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', handleDomReady)
        } else {
            handleDomReady()
        }
    
        return () => {
            document.removeEventListener('DOMContentLoaded', handleDomReady)
        }
    }, [])

    return null
}